module.exports = __webpack_public_path__ + "media/components/assets/images/default_profile-3c5dab2d0c97a519750e0ed46545a197.png";